function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Created by pzf on 2018/10/31
 *
 */
import { Form } from 'mkui-fd';
/**
 *
 * @param size 后端定义的尺寸 1,2,3,4
 * @param columNumber 每行列数
 * @returns {number}
 */

export function getColSpan(size, columnNumber) {
  var span = 24 / columnNumber * size;
  return span > 24 ? 24 : span;
}
export function getProps(field) {
  var _field$property = field.property,
      rules = _field$property.rules,
      name = _field$property.name,
      other = _objectWithoutProperties(_field$property, ["rules", "name"]);

  return other;
}
export function mapPropsToFields(values, fields) {
  var formFields = {};
  fields.forEach(function (field) {
    formFields[field.identifier] = Form.createFormField({
      value: values[field.identifier]
    });
  });
  return formFields;
}
//# sourceMappingURL=util.js.map
